export default __webpack_public_path__ + "static/broadcastImg2-28248caa672a14c8444f30e6799da5c9.webp";